import { render } from "./PhotoUploaderV3Component.vue?vue&type=template&id=645fdf15&scoped=true&ts=true"
import script from "./PhotoUploaderV3Component.vue?vue&type=script&lang=ts"
export * from "./PhotoUploaderV3Component.vue?vue&type=script&lang=ts"

import "./PhotoUploaderV3Component.vue?vue&type=style&index=0&id=645fdf15&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-645fdf15"]])

export default __exports__